import { Tabs } from 'antd';
import React, { useEffect } from 'react'
// import Upcoming from './Upcoming'
import Recent from './Recent'
import { translate } from 'react-i18next'

const { TabPane } = Tabs;

const TabsList = ({ roomList, keycloak, authenticated, language, conferenceCount, t }) => {
    // const setHeight = () => {
    //     const item = document.querySelector(".room-list")
    //     const tabItem = document.querySelector(".tabs-room-recent")
    //     const length = roomList.length <= 3 ? roomList.length : 3
    //     if (item) {
    //         const heightRoomList = ((item.offsetHeight + 16) * length)
    //         let tempHeightRoomList
    //         if (heightRoomList > 0) {
    //             tempHeightRoomList = heightRoomList
    //         }
    //         tabItem.style.height = heightRoomList > 0 ? `${heightRoomList}px` : `${tempHeightRoomList}px`
    //     }
    // }

    const setHeightUpcoming = () => {
        const item = document.querySelector(".reservation-room-lists")
        const tabItem = document.querySelector(".tabs-room-upcoming")
        if (item) {
            const heightRoomList = (item.offsetHeight * 3)
            let tempHeightRoomList
            if (heightRoomList > 0) {
                tempHeightRoomList = heightRoomList
            }
            tabItem.style.height = heightRoomList > 0 ? `${heightRoomList}px` : `${tempHeightRoomList}px`
        }
    }

    useEffect(() => {
        // setHeight()
        setHeightUpcoming()
        // document.addEventListener('resize', setHeight)
        document.addEventListener('resize', setHeightUpcoming)
    })

    return (
        <>
            <Tabs style={{ width: '100%', marginLeft: '10px' }} className="tabs-room-list" defaultActiveKey="1" >
                <TabPane tab={t('tab_recent')} key="1" className="tabs-room-recent" style={{ overflow: 'auto' }}>
                    <Recent roomList={roomList} conferenceCount={conferenceCount} keycloak={keycloak} language={language} />
                </TabPane>
                {/* <TabPane tab={t('tab_upcoming')} key="2" className="tabs-room-upcoming">
                    <Upcoming keycloak={keycloak} authenticated={authenticated} language={language} />
                </TabPane> */}
            </Tabs>
        </>
    )
}

export default translate()(TabsList)
